<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";

export default {
    name: 'Title_Job',
    props: {},
    components: {
        Title_Base,
    },

    data() {
        return {
        };
    },

    methods: {},

    computed: {
        icon() {
            return "$job";
        },

        text() {
            return this.$store.getters["JobHub/ParentJobName"];
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>